import { DATA_BACT_LN_MODEL , getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'
import axios from "axios";

export default {
    namespaced: true,

    state: {

        buffBACTDatPrepareDat : "",
        buffBACTDatCtDat : "",
        dataBACTSpecLN: Object.assign( {} ,DATA_BACT_LN_MODEL) ,

        mstBactDat: [] ,
        mstDrugDat: [] ,
        mstMicDat  : [] ,
        mstResultDat: [],
        mstMethod:[],
        mstMethodResult:[],
        tmplateBact:{}
    },

    getters: {

    },

    mutations: {
        setMstMethod (state, mstMethod) {
            state.mstMethod = mstMethod
        },


        setMstMethodResult (state, mstMethodResult) {
            state.mstMethodResult = mstMethodResult
        },




        setTmplateBact (state, tmplateBact) {
            state.tmplateBact = tmplateBact
        },


        setMstResultDat (state, mstResultDat) {
            state.mstResultDat = mstResultDat
        },

        setMstMicDat (state, mstMicDat) {
            state.mstMicDat = mstMicDat
        },

        setMstDrugDat (state, mstDrugDat) {
            state.mstDrugDat = mstDrugDat
        },

        setMstBactDat (state, mstBactDat) {
            state.mstBactDat = mstBactDat
        },


        setDataBACTSpecLN (state, dataBACTSpecLN) {
            state.dataBACTSpecLN =  dataBACTSpecLN
        },

        setBuffBACTDatPrepareDat (state, buffBACTDatPrepareDat) {
            state.buffBACTDatPrepareDat = buffBACTDatPrepareDat
        },

        setBuffBACTDatCtDat (state, buffBACTDatCtDat) {
            state.buffBACTDatCtDat = buffBACTDatCtDat
        },

    },

    actions: {
        produceDoneFetching({commit},doneFetching){
            commit('setDoneFetching', doneFetching)
        },

        produceBuffBACTDatPrepareDat({commit},buffBACTDatPrepareDat){
            commit('setBuffBACTDatPrepareDat', buffBACTDatPrepareDat)
        },

        produceBuffBACTDatCtDat({commit},buffDatCtDat){
            commit('setBuffBACTDatCtDat', buffDatCtDat)
        },



        fetchMiscMasterDataForBact({commit},datTo) {
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_misc_masterdata_for_bact`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setMstResultDat', res.data.result_mst)
                        commit('setMstMicDat', res.data.mic)
                        commit('setMstDrugDat', res.data.drug)
                        commit('setMstBactDat', res.data.bact)
                        commit('setTmplateBact', res.data.tmplate)
                        commit('setMstMethod', res.data.method_mst)
                        commit('setMstMethodResult', res.data.method_result_mst)

                        resolve(res.data)
                    })
            }    )

        },


        fetchBACTOLDDat({commit},datTo){
            // console.log(datTo) 
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/labbact_by_spechnspecln`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log( JSON.stringify(res.data.data_bact[0]))
                        commit('setDataBACTSpecLN', JSON.parse(JSON.stringify(res.data))  ) 
                        // commit('setBuffBACTDatPrepareDat', res.data.dat_prepare.dat)


                        // // const  tmp = res.data.dat_prepare.dat
                        // // console.log(tmp)
                        // // buffer.from("SGVsbG8gVmlzaGFsIFRoYWt1cg==", 'base64').toString('ascii')
                        if(res.data.dat_prepare.dat === null){
                            commit('setBuffBACTDatPrepareDat',"")
                        }else{
                            commit('setBuffBACTDatPrepareDat', Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8') )
                        }
                        // // **************************************************
                        if(res.data.dat_ct.dat === null){
                            commit('setBuffBACTDatCtDat',"")
                        }else{
                            commit('setBuffBACTDatCtDat', Buffer.from(res.data.dat_ct.dat, 'base64').toString('utf-8') )
                        }
                        // // console.log( Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8'))
                        resolve(res.data)
                    })
            })
        }
    }
}